import {
  InternalViewModel, StringPropertyViewModel, GuidPropertyViewModel, EnumPropertyViewModel, BoolPropertyViewModel, NumericPropertyViewModel, DateTimeOffsetPropertyViewModel, DateTimePropertyViewModel,
  NNumericPropertyViewModel, NDateTimeOffsetPropertyViewModel, NDateTimePropertyViewModel
} from '@nts/std';
import { OtherData } from '../../domain-models/other-data';
import { ReceiptParamsIdentity } from '../../domain-models/receipt-params.identity';

export class GeneratedOtherDataViewModel extends InternalViewModel<OtherData, ReceiptParamsIdentity> {

  private _id: NumericPropertyViewModel<number>;

  public get id(): NumericPropertyViewModel<number> {
    return this.getNumericPropertyViewModel<number>((value) => { this._id = value; }, this._id, 'id');
  }

  private _peopleQuantity: NumericPropertyViewModel<number>;

  public get peopleQuantity(): NumericPropertyViewModel<number> {
    return this.getNumericPropertyViewModel<number>((value) => { this._peopleQuantity = value; }, this._peopleQuantity, 'peopleQuantity');
  }

  private _guestQuantity: NumericPropertyViewModel<number>;

  public get guestQuantity(): NumericPropertyViewModel<number> {
    return this.getNumericPropertyViewModel<number>((value) => { this._guestQuantity = value; }, this._guestQuantity, 'guestQuantity');
  }

}
